import { render, staticRenderFns } from "./ZoneListPage.vue?vue&type=template&id=2d1abb9a&scoped=true"
import script from "./ZoneListPage.vue?vue&type=script&lang=js"
export * from "./ZoneListPage.vue?vue&type=script&lang=js"
import style0 from "./ZoneListPage.vue?vue&type=style&index=0&id=2d1abb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1abb9a",
  null
  
)

export default component.exports